/**
 * AMAI OPS — tokens de design em JavaScript.
 *
 * Espelho de `styles/tokens.css`, para o que precisa da cor fora do CSS:
 * gráfico, canvas, ícone colorido por estado, style inline.
 *
 * O produto é CLARO. As cores semânticas aqui são as de TEXTO — escuras o
 * bastante para 4,5:1 sobre branco —, porque o uso mais comum destas
 * constantes é pintar um VALOR em linha (vencido em vermelho, saldo em
 * verde). Elas também servem para ponto e barra: escuro sobre branco lê bem.
 *
 * Verde-água é a MARCA (`mare`), não estado. Verde de "pago" é outro verde,
 * mais amarelado, e os dois não se confundem.
 */
export const T = {
  bg: '#F5F6F8',
  bgSidebar: '#FFFFFF',
  bgSubtle: '#F0F2F5',
  card: '#FFFFFF',
  row: '#FFFFFF',
  raised: '#FFFFFF',
  overlay: '#FFFFFF',
  input: '#FFFFFF',
  hover: '#F3F5F7',

  line: '#E3E6EA',
  lineStrong: '#CDD2D9',
  lineField: '#C9CED6',

  ink: '#17202B',
  inkSoft: '#475262',
  inkFaint: '#626C7C',
  inkPlaceholder: '#6B7484',

  /** Botão principal: branco em cima passa em 5,6:1. */
  action: '#0B7470',
  actionHover: '#095E5B',
  /** Verde-água de identidade: traço, ponto, foco. Não escreve texto. */
  brand: '#0E8F8B',
  mare: '#0B7470',
  mareText: '#0B7470',

  green: '#15803D',
  amber: '#B45309',
  red: '#B42318',
  info: '#1D4ED8',
  greenText: '#15803D',
  amberText: '#B45309',
  redText: '#B42318',
  infoText: '#1D4ED8',
  /** Cor CHEIA, para série de gráfico e barra — nunca para texto. */
  greenSolid: '#16A34A',
  amberSolid: '#F59E0B',
  redSolid: '#DC2626',
  infoSolid: '#2563EB',
  redFill: '#B42318',

  greenTint: '#ECFDF3',
  amberTint: '#FFF6E5',
  redTint: '#FEF3F2',
  mareTint: '#E8F4F3',

  /* --------------------------------------------------- apelidos herdados */
  surface: '#F5F6F8',
  petroleo: '#FFFFFF',
  petroleoSoft: '#F0F2F5',
  petroleoLine: '#E3E6EA',
  hair: '#ECEFF2',
  mareDark: '#0B7470',
  mareLight: '#0E8F8B',
  amberLine: '#F5D9A6',
  redLine: '#F6C9C4',
} as const;

export const FONTS = {
  display: "'Inter', system-ui, sans-serif",
  ui: "'Inter', system-ui, sans-serif",
  /** Só atalho de teclado. Número usa Inter com algarismos tabulares. */
  mono: "ui-monospace, 'SFMono-Regular', Menlo, monospace",
} as const;

export type Tone = 'neutral' | 'good' | 'warn' | 'bad' | 'info';
